/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useCallback, useEffect, useState} from 'react';

/**
 * @useRefreshState
 *
 * Simple hook for obtaining previous state value
 *
 * ```typescript
 * import {useRefreshState} from '@ion/dls/src/hooks/useRefreshState';
 *
 * //...in component,
 *
 *  const {refresh, updateRefresh} = useRefreshState(accountId);
 *
 * ```
 */
export const useRefreshState = (accountId: number) => {
  const [refresh, setRefresh] = useState<boolean>(false);

  useEffect(() => {
    setRefresh(true);
  }, [accountId]);

  const updateRefresh = useCallback(() => {
    setRefresh(!refresh);
  }, [refresh]);

  return {refresh, updateRefresh};
};

export default useRefreshState;
